import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import React from 'react';
import CustomSignatureWrapper from './CustomSignatureWrapper';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';

loadDOMComponent({
	selector: 'react-user-settings-custom-signature',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<CustomSignatureWrapper />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
